import { useRecoilValue } from 'recoil';

import { userRole } from '../components/state/atoms';
import { PERMISSION } from '../config/permissions';

export const usePermissions = () => {
  const userAuthority = useRecoilValue(userRole) as string;

  // Admin
  // Loan Officer
  // Loan Processor
  const isAdmin = () => {
    return userAuthority === PERMISSION.ADMIN;
  };

  const isLoanOfficer = () => {
    return userAuthority === PERMISSION.LOAN_OFFICER;
  };
  const isLoanProcessor = () => {
    return userAuthority === PERMISSION.LOAN_PROCESSOR;
  };
  const isOwner = () => {
    return userAuthority === PERMISSION.OWNER;
  };
  const isSuperAdmin = () => {
    return userAuthority === PERMISSION.SUPER_ADMIN;
  };

  const hasOwnerPermissions = () => isSuperAdmin() || isOwner();

  const hasAdminPermissions = () => isAdmin() || hasOwnerPermissions();

  const hasLOPermissions = () =>
    hasAdminPermissions() || isLoanOfficer() || hasOwnerPermissions();

  const hasLPPermissions = () =>
    hasAdminPermissions() || isLoanProcessor() || hasOwnerPermissions();

  return {
    isAdmin,
    isLoanOfficer,
    isOwner,
    isSuperAdmin,
    hasOwnerPermissions,
    hasAdminPermissions,
    hasLOPermissions,
    hasLPPermissions,
  };
};
